import { createAction, props } from '@ngrx/store';
import { QueueAgentStatus, QueueCallerStatus } from 'generated/graphql-types';

export const extensionCallQueueIsLoggedInChanged = createAction(
   '[Extension Call Queue Hub] Extension Phone DND Changed',
   props<{
      queueMemeberId: number;
      queueExtensionId: number;
      isLoggedIn: boolean;
      agentStatus: QueueAgentStatus | null;
   }>()
);

export const extensionCallQueueStatusChanged = createAction(
   '[Extension Call Queue Hub] Extension Phone DND Status Changed',
   props<{
      extensionIds: number[];
      agentExtensionId: number;
      agentStatus: QueueAgentStatus | null;
      endWrapUpTime?: any | null;
   }>()
);

export const extensionCallQueueCallsChanged = createAction(
   '[Extension Call Queue Hub] Extension Phone Queue Calls Changed',
   props<{
      agentExtension: any;
      queueExtension: any | null;
      callDetailId: number;
      callerIdName: string;
      callerIdNumber: string;
      callerStatus: QueueCallerStatus;
      queueExtensionId: number;
      queueHistoryId: number;
      startPosition: number;
      callCompleteDateTime: any;
      isCallBackRequested: any;
      callbackAttempts: number;
      enqueuedDateTime: any;
      callDispositionId: any;
      answeredDateTime: any;
      serverName: string;
      callerChannelId: string;
      sipCallId: string;
      hasPreventEmptyQueue: boolean;
      waitTime: number;
   }>()
);

export const extensionCallQueueCompleted = createAction(
   '[Extension Call Queue Hub] Extension Phone Queue Calls Ended',
   props<{
      queueHistoryId: number;
      callCompleteDateTime: any;
   }>()
);
